module.exports = __webpack_public_path__ + "static/media/9DESA11.46fa64c5.jpg";